module.exports = __webpack_public_path__ + "static/img/BG_Licm.3b95698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BG_Licm.jpg
// module id = UQul
// module chunks = 1